
<!-- Grid Syncfusion ref. este input. -->
<input type='text' [(value)]='val' #inputX name='{{name}}'
    style="height: 0;border-width: 0; width: 0;margin: 0;padding: 0;position: absolute;opacity: 0;" class='' />

<div class="e-in54put-group  e-fl5oat-input" [formGroup]='model'>

    <label class="ng-select-label" *ngIf='label'>{{ label }}</label>

    <ng-select #select class='select-has-tooltip' [items]='dsItems' [multiple]='_multiple'
        [closeOnSelect]='!multiple' [placeholder]='placeholder' bindLabel="text" [loadingText]="'Carregando...'"
        [notFoundText]="'Nenhum item encontrado.'" [appendTo]="appendTo" [clearable]='clearable' [typeahead]="filter$"
        [searchable]="false" [virtualScroll]='true' formControlName='value' (open)='onOpen()'
        [loading]="loading || loadingDefaults" [readonly]='loadingDefaults || !enabled || !hasDataSourceAttached'
        (scrollToEnd)='onScrollToEnd()' (scroll)='onScroll($event)'>

        <!-- Template - Item -->
        <ng-template ng-label-tmp let-item="item" let-clear='clear'>

            <ng-container *ngIf='labelTemplate !== undefined'>
                <ng-container *ngTemplateOutlet="labelTemplate; context: { item: item, clear: clear }">
                </ng-container>
            </ng-container>

            <ng-container *ngIf='labelTemplate === undefined'>

                <span class="ng-value-icon left" (click)="clear(item)" *ngIf="item.disabled !== true">×</span>

                <span class="ng-value-label" [title]="item.text">{{ item.text }}</span>

            </ng-container>

        </ng-template>

        <ng-template ng-option-tmp let-item="item">
            <div [title]="item.text">
                <ng-container *ngIf='optionTemplate !== undefined'>
                    <ng-container *ngTemplateOutlet="optionTemplate; context: { item: item }">
                    </ng-container>
                </ng-container>

                <ng-container *ngIf='optionTemplate === undefined'>
                    <span class="ng-option-label" [title]="item.text">{{ item.text }}</span>
                </ng-container>
            </div>
        </ng-template>


        <ng-template ng-header-tmp *ngIf='searchable'>
            <input axAutoFocus style="width: 100%; line-height: 24px" type="text" class="e-control  e-textbox e-lib"
                (input)="filterInput($event)" />
        </ng-template>

        <ng-template ng-footer-tmp>
            <div *ngIf="hasError && !loading && !loadingDefaults">Ocorreu um problema ao carregar os itens.</div>
        </ng-template>


        <ng-template ng-loadingspinner-tmp>
            <div _ngcontent-sjk-c10="" class="select-spinner e-spinner-pane e-spin-show">
                <div _ngcontent-sjk-c10="" class="e-spinner-inner">
                    <svg id="YsoYc" class="e-spin-fabric" viewBox="0 0 30 30"
                        style="transform-origin: 8px 8px 8px; height: 16px; width: 16px;    animation: fabric-spinner-rotate 0.3s infinite cubic-bezier(0.53, 0.21, 0.29, 0.67);">
                        <path class="e-path-circle" d="M 15 15 m -15 0 a 15 15 0 1 0 30 0 a 15 15 0 1 0 -30 0">
                        </path>
                        <path class="e-path-arc"
                            d="M 25.606601717798213 4.3933982822017885 A 15 15 0 0 0 4.393398282201785 4.3933982822017885">
                        </path>
                    </svg>
                </div>
            </div>
        </ng-template>

    </ng-select>


</div>